<template>
  <div class="doctor-info-wrapper">
    <div class="doctor-user-info">
      <div class="doctor-item">
        医师：{{ data.name }}
        <img v-if="data.doctorSignUrl" :src="data.doctorSignUrl" alt="" @error="$emit('error', 'doctor')" />
      </div>
      <div class="doctor-item">
        审核：{{ data.prePharmacistName }}
        <img
          v-if="data.prePharmacistSignUrl"
          :src="data.prePharmacistSignUrl"
          alt=""
          @error="$emit('error', 'prePharmacist')"
        />
      </div>
      <div class="doctor-item">
        药师：{{ data.pharmacistName }}
        <img v-if="data.pharmacistSignUrl" :src="data.pharmacistSignUrl" alt="" @error="$emit('error', 'pharmacist')" />
      </div>
      <div class="doctor-item">
        调配：
        <img v-if="data.dispenserUrl" :src="data.dispenserUrl" alt="" @error="$emit('error', 'dispense')" />
      </div>
      <div class="doctor-item">
        核对/发药：
        <img v-if="data.dispatcherUrl" :src="data.dispatcherUrl" alt="" @error="$emit('error', 'doctor')" />
      </div>
      <div class="doctor-item">金额：{{ data.amount }}</div>
    </div>
    <div class="doctor-attention">{{ data.validityMemo }}</div>
    <div class="doctor-remind">{{ data.memo }}</div>
  </div>
</template>

<script>
export default {
  name: 'DoctorInfo',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style scoped lang="scss">
.doctor-info-wrapper {
  padding-top: 12pt;

  .doctor-user-info {
    display: flex;
    flex-direction: column;
    gap: 10pt;
    margin-bottom: 10pt;

    .doctor-item {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      font-size: 10pt;
      line-height: 1.4;
      color: #000;

      img {
        width: 120pt !important;
      }
    }
  }

  .doctor-attention {
    font-size: 8pt;
    line-height: 1.4;
    color: #000;
  }

  .doctor-remind {
    margin-top: 12pt;
    font-size: 8pt;
    line-height: 1.4;
  }
}
</style>
